/**
 * Effective GSM-7 length for SMS bodies with merge placeholders.
 * Placeholders count as substituted width (e.g. %link% → 25), not the literal token length.
 * For Media Devoted | Created By Ciro Autiero
 */

/** Single-segment cap after real values replace merge fields. */
export const SMS_GSM7_SINGLE_SEGMENT_LIMIT = 160;

/** Known merge tokens → character count when substituted (SMSWiser / campaign rules). */
export const SMS_PLACEHOLDER_EFFECTIVE_LENGTHS: Readonly<Record<string, number>> = {
  '%first_name%': 8,
  '%last_name%': 8,
  '%phone%': 11,
  '%dob%': 10,
  '%address%': 16,
  '%zip_code%': 7,
  '%link%': 25,
  '%email%': 25,
  '%city%': 8,
  '%state%': 5,
  '%optoutlink%': 25,
  '%dd%': 2,
  '%mm%': 2,
  '%yyyy%': 4,
  '%click_id%': 7,
};

const PLACEHOLDERS_LONGEST_FIRST = Object.keys(SMS_PLACEHOLDER_EFFECTIVE_LENGTHS).sort(
  (a, b) => b.length - a.length,
);

/**
 * Length as counted for one GSM-7 segment after substitution: literal chars (1 each)
 * plus effective width for each known %...% token. Unknown `%` sequences count per character.
 */
export function smsEffectiveGsmLength(text: string): number {
  let i = 0;
  let total = 0;
  while (i < text.length) {
    let matched = false;
    for (const key of PLACEHOLDERS_LONGEST_FIRST) {
      if (text.startsWith(key, i)) {
        total += SMS_PLACEHOLDER_EFFECTIVE_LENGTHS[key]!;
        i += key.length;
        matched = true;
        break;
      }
    }
    if (!matched) {
      total += 1;
      i += 1;
    }
  }
  return total;
}

export function isSmsWithinEffectiveGsmLimit(
  text: string,
  limit: number = SMS_GSM7_SINGLE_SEGMENT_LIMIT,
): boolean {
  return smsEffectiveGsmLength(text) <= limit;
}
